import { render, staticRenderFns } from "./DocumentenView.vue?vue&type=template&id=67f056e2"
import script from "./DocumentenView.vue?vue&type=script&lang=js"
export * from "./DocumentenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports